import { AxiosResponse } from "axios";
import { Base } from "@tt-app/api/base";
import { Course } from "@tt-app/types";
import { API_ENDPOINTS } from "@tt-app/constants/api";

const {
  CONTENT: { BOOKMARK, BOOKMARKS, COURSE, ORGANIZATION_COURSES, RECOMMENDED_COURSES }
} = API_ENDPOINTS;

class Content extends Base {
  async add_bookmark(payload: any) {
    return this.httpClient.put(
      `${BOOKMARK}/${payload.courseUuid}/bookmarked/`,
      {},
      { headers: payload.headers }
    );
  }

  async bookmarked_courses(payload: any): Promise<AxiosResponse<Course[]>> {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };
    return this.httpClient.get(`${BOOKMARKS}`, { headers });
  }

  async course(payload: any): Promise<AxiosResponse<Course>> {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };
    return this.httpClient.get(`${COURSE}/${payload.uuid}/`, { headers });
  }

  async organization_courses(payload: any): Promise<AxiosResponse<Course[]>> {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };
    return this.httpClient.get(`${ORGANIZATION_COURSES}`, { headers });
  }

  async remove_bookmark(payload: any): Promise<AxiosResponse<void>> {
    return this.httpClient.delete(`${BOOKMARK}/${payload.courseUuid}/bookmarked/`, {
      headers: payload.headers
    });
  }

  async recommended_courses(payload: any): Promise<AxiosResponse<Course[]>> {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };
    return this.httpClient.get(`${RECOMMENDED_COURSES}`, { headers });
  }
}

export { Content };
